import React from 'react'
import PropTypes from 'prop-types'

class CancellationReason extends React.Component {
  constructor (props) {
    super(props)

    this.handleReasonChange = this.handleReasonChange.bind(this)
    this.handleDetailsChange = this.handleDetailsChange.bind(this)
  }

  handleReasonChange (e) {
    this.props.onReasonChange(this.props.question, this.props.reason)
  }

  handleDetailsChange (e) {
    this.props.onDetailsChange(this.props.question, this.props.reason, e.target.value)
  }

  render () {
    return (
      <div className='CancellationReason radio'>
        <label className='CancellationReason__label'>
          <input type='radio' name={'question_' + this.props.question.key} checked={this.props.selected} value={this.props.reason.key} onChange={this.handleReasonChange} className='CancellationReason__radioInput' />
          {this.props.reason.text}
        </label>

        {this.props.selected && this.props.reason.detailsPrompt &&
          <textarea type='text' rows='3' value={this.props.details} placeholder={this.props.reason.detailsPrompt} onChange={this.handleDetailsChange} className='CancellationReason__textInput form-control' />
        }
      </div>
    )
  }
}

CancellationReason.propTypes = {
  question: PropTypes.object.isRequired,
  reason: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  details: PropTypes.string,
  onReasonChange: PropTypes.func.isRequired,
  onDetailsChange: PropTypes.func.isRequired
}

export default CancellationReason
